"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTracker = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable class-methods-use-this */
/**
 * Base for all Tracker class
 */
var BaseTracker = exports.BaseTracker = /*#__PURE__*/function () {
  /**
   * Create a Tracker
   * @param {Object} options specify the tracker options
   * @param {(Object) => String} options.mapUserIdentity function to map user identity,
   * it takes user `profile`
   * supply by the event caller and return the userIdentity
   * @param {(Object) => Object} options.mapUserProfile function to map user profile
   * to send to the tracker
   */
  function BaseTracker(options) {
    _classCallCheck(this, BaseTracker);
    var o = _lodash.default.merge({
      mapUserIdentity: function mapUserIdentity(p) {
        return p;
      },
      mapUserProfile: function mapUserProfile(p) {
        return p;
      }
    }, options);
    this.mapUserIdentity = o.mapUserIdentity;
    this.mapUserProfile = o.mapUserProfile;
  }

  /**
   * Dummy function for tracking page view
   */
  _createClass(BaseTracker, [{
    key: "trackPageView",
    value: function trackPageView() {}

    /**
     * Dummy function for identify user
     */
  }, {
    key: "identifyUser",
    value: function identifyUser() {}

    /**
     * Dummy function for identify user on the amplitude only
     */
  }, {
    key: "identifyAmplitude",
    value: function identifyAmplitude() {}

    /**
     * Dummy function for track event
     */
  }, {
    key: "trackEvent",
    value: function trackEvent() {}

    /**
     * Dummy function for track button click
     */
  }, {
    key: "trackButtonClick",
    value: function trackButtonClick() {}

    /**
     * Dummy function for set alias of user
     */
  }, {
    key: "setAliasUser",
    value: function setAliasUser() {}

    /**
     * Dummy function for user logged out
     */
  }, {
    key: "logout",
    value: function logout() {}
  }]);
  return BaseTracker;
}();